"use strict";
exports.__esModule = true;
exports.ICON_SIZE = exports.TYPOGRAPHY = exports.ROUNDED = exports.REVERSE_HOVER_COLORS = exports.OUTLINED_HOVER_COLORS = exports.HOVER_COLORS = exports.REVERSE_COLORS = exports.OUTLINED_COLORS = exports.COLORS = exports.SIZES = exports.VARIANTS = void 0;
var text_props_1 = require("../text/text.props");
exports.VARIANTS = {
    outlined: '!bg-white border hover:bg-white',
    filled: 'border'
};
exports.SIZES = {
    huge: 'h-8 min-w-8',
    large: 'h-8 min-w-8',
    medium: 'h-8 min-w-8',
    small: 'h-6 min-w-6',
    tiny: 'h-5 min-w-5'
};
exports.COLORS = {
    primary: 'bg-primary-600 border-primary-600 text-white',
    secondary: 'bg-secondary-600 border-secondary-600 text-white',
    tertiary: 'bg-tertiary-600 border-tertiary-600 text-white',
    info: 'bg-info-600 border-info-600 text-white',
    danger: 'bg-danger-600 border-danger-600 text-white',
    warning: 'bg-warning-600 border-warning-600 text-white',
    success: 'bg-success-600 border-success-600 text-white',
    control: 'bg-control-600 border-control-600 text-white',
    black: 'bg-black border-black text-white',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'bg-slate-600 border-slate-600 text-white',
    zinc: 'bg-zinc-600 border-zinc-600 text-white',
    neutral: 'bg-neutral-600 border-neutral-600 text-white',
    stone: 'bg-stone-600 border-stone-600 text-white',
    red: 'bg-red-600 border-red-600 text-white',
    orange: 'bg-orange-600 border-orange-600 text-white',
    amber: 'bg-amber-600 border-amber-600 text-white',
    yellow: 'bg-yellow-600 border-yellow-600 text-white',
    lime: 'bg-lime-600 border-lime-600 text-white',
    green: 'bg-green-600 border-green-600 text-white',
    emerald: 'bg-emerald-600 border-emerald-600 text-white',
    teal: 'bg-teal-600 border-teal-600 text-white',
    cyan: 'bg-cyan-600 border-cyan-600 text-white',
    sky: 'bg-sky-600 border-sky-600 text-white',
    blue: 'bg-blue-600 border-blue-600 text-white',
    indigo: 'bg-indigo-600 border-indigo-600 text-white',
    violet: 'bg-violet-600 border-violet-600 text-white',
    purple: 'bg-purple-600 border-purple-600 text-white',
    fuchsia: 'bg-fuchsia-600 border-fuchsia-600 text-white',
    pink: 'bg-pink-600 border-pink-600 text-white',
    rose: 'bg-rose-600 border-rose-600 text-white'
};
exports.OUTLINED_COLORS = {
    primary: 'bg-white border border-primary text-primary',
    danger: 'bg-white border border-danger text-danger',
    warning: 'bg-white border border-warning text-warning',
    secondary: 'bg-white border border-secondary text-secondary',
    tertiary: 'bg-white border border-tertiary text-tertiary',
    success: 'bg-white border border-success text-success',
    info: 'bg-white border border-info text-info',
    control: 'bg-white border border-control text-control',
    black: 'bg-white border border-black text-black',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'bg-white border border-slate-500 text-slate-500',
    zinc: 'bg-white border border-zinc-500 text-zinc-500',
    neutral: 'bg-white border border-neutral-500 text-neutral-500',
    stone: 'bg-white border border-stone-500 text-stone-500',
    red: 'bg-white border border-red-500 text-red-500',
    orange: 'bg-white border border-orange-500 text-orange-500',
    amber: 'bg-white border border-amber-500 text-amber-500',
    yellow: 'bg-white border border-yellow-500 text-yellow-500',
    lime: 'bg-white border border-lime-500 text-lime-500',
    green: 'bg-white border border-green-500 text-green-500',
    emerald: 'bg-white border border-emerald-500 text-emerald-500',
    teal: 'bg-white border border-teal-500 text-teal-500',
    cyan: 'bg-white border border-cyan-500 text-cyan-500',
    sky: 'bg-white border border-sky-500 text-sky-500',
    blue: 'bg-white border border-blue-500 text-blue-500',
    indigo: 'bg-white border border-indigo-500 text-indigo-500',
    violet: 'bg-white border border-violet-500 text-violet-500',
    purple: 'bg-white border border-purple-500 text-purple-500',
    fuchsia: 'bg-white border border-fuchsia-500 text-fuchsia-500',
    pink: 'bg-white border border-pink-500 text-pink-500',
    rose: 'bg-white border border-rose-500 text-rose-500'
};
exports.REVERSE_COLORS = {
    primary: 'bg-primary-100 border-primary-100 text-primary-800',
    secondary: 'bg-secondary-100 border-secondary-100 text-secondary-800',
    tertiary: 'bg-tertiary-100 border-tertiary-100 text-tertiary-800',
    info: 'bg-info-100 border-info-100 text-info-800',
    danger: 'bg-danger-100 border-danger-100 text-danger-800',
    warning: 'bg-warning-100 border-warning-100 text-warning-800',
    success: 'bg-success-100 border-success-100 text-success-800',
    control: 'bg-control-100 border-control-100 text-control-800',
    black: 'bg-control-100 border-control-100 text-black',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'bg-slate-100 border-slate-100 text-slate-800',
    zinc: 'bg-zinc-100 border-zinc-100 text-zinc-800',
    neutral: 'bg-neutral-100 border-neutral-100 text-neutral-800',
    stone: 'bg-stone-100 border-stone-100 text-stone-800',
    red: 'bg-red-100 border-red-100 text-red-800',
    orange: 'bg-orange-100 border-orange-100 text-orange-800',
    amber: 'bg-amber-100 border-amber-100 text-amber-800',
    yellow: 'bg-yellow-100 border-yellow-100 text-yellow-800',
    lime: 'bg-lime-100 border-lime-100 text-lime-800',
    green: 'bg-green-100 border-green-100 text-green-800',
    emerald: 'bg-emerald-100 border-emerald-100 text-emerald-800',
    teal: 'bg-teal-100 border-teal-100 text-teal-800',
    cyan: 'bg-cyan-100 border-cyan-100 text-cyan-800',
    sky: 'bg-sky-100 border-sky-100 text-sky-800',
    blue: 'bg-blue-100 border-blue-100 text-blue-800',
    indigo: 'bg-indigo-100 border-indigo-100 text-indigo-800',
    violet: 'bg-violet-100 border-violet-100 text-violet-800',
    purple: 'bg-purple-100 border-purple-100 text-purple-800',
    fuchsia: 'bg-fuchsia-100 border-fuchsia-100 text-fuchsia-800',
    pink: 'bg-pink-100 border-pink-100 text-pink-800',
    rose: 'bg-rose-100 border-rose-100 text-rose-800'
};
exports.HOVER_COLORS = {
    primary: 'hover:bg-primary-dark hover:border-primary-dark active:bg-primary-light',
    secondary: 'hover:bg-secondary-dark hover:border-secondary-dark active:bg-secondary-light',
    tertiary: 'hover:bg-tertiary-dark hover:border-tertiary-dark active:bg-tertiary-light',
    info: 'hover:bg-info-dark hover:border-info-dark active:bg-info-light',
    danger: 'hover:bg-danger-dark hover:border-danger-dark active:bg-danger-light',
    warning: 'hover:bg-warning-dark hover:border-warning-dark active:bg-warning-light',
    success: 'hover:bg-success-dark hover:border-success-dark active:bg-success-light',
    control: 'hover:bg-control-dark hover:border-control-dark active:bg-control-light',
    black: 'hover:bg-primary-dark hover:border-primary-dark active:bg-primary-light',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'hover:bg-slate-700 hover:border-slate-700 active:bg-slate-300',
    zinc: 'hover:bg-zinc-700 hover:border-zinc-700 active:bg-zinc-300',
    neutral: 'hover:bg-neutral-700 hover:border-neutral-700 active:bg-neutral-300',
    stone: 'hover:bg-stone-700 hover:border-stone-700 active:bg-stone-300',
    red: 'hover:bg-red-700 hover:border-red-700 active:bg-red-300',
    orange: 'hover:bg-orange-700 hover:border-orange-700 active:bg-orange-300',
    amber: 'hover:bg-amber-700 hover:border-amber-700 active:bg-amber-300',
    yellow: 'hover:bg-yellow-700 hover:border-yellow-700 active:bg-yellow-300',
    lime: 'hover:bg-lime-700 hover:border-lime-700 active:bg-lime-300',
    green: 'hover:bg-green-700 hover:border-green-700 active:bg-green-300',
    emerald: 'hover:bg-emerald-700 hover:border-emerald-700 active:bg-emerald-300',
    teal: 'hover:bg-teal-700 hover:border-teal-700 active:bg-teal-300',
    cyan: 'hover:bg-cyan-700 hover:border-cyan-700 active:bg-cyan-300',
    sky: 'hover:bg-sky-700 hover:border-sky-700 active:bg-sky-300',
    blue: 'hover:bg-blue-700 hover:border-blue-700 active:bg-blue-300',
    indigo: 'hover:bg-indigo-700 hover:border-indigo-700 active:bg-indigo-300',
    violet: 'hover:bg-violet-700 hover:border-violet-700 active:bg-violet-300',
    purple: 'hover:bg-purple-700 hover:border-purple-700 active:bg-purple-300',
    fuchsia: 'hover:bg-fuchsia-700 hover:border-fuchsia-700 active:bg-fuchsia-300',
    pink: 'hover:bg-pink-700 hover:border-pink-700 active:bg-pink-300',
    rose: 'hover:bg-rose-700 hover:border-rose-700 active:bg-rose-300'
};
exports.OUTLINED_HOVER_COLORS = {
    primary: 'hover:bg-primary-50 hover:border-primary-dark hover:text-primary-dark active:border-primary-light active:text-primary-light',
    danger: 'hover:bg-danger-50 hover:border-danger-dark hover:text-danger-dark active:border-danger-light active:text-danger-light',
    warning: 'hover:bg-warning-50 hover:border-warning-dark hover:text-warning-dark active:border-warning-light active:text-warning-light',
    secondary: 'hover:bg-secondary-50 hover:border-secondary-dark hover:text-secondary-dark active:border-secondary-light active:text-secondary-light',
    tertiary: 'hover:bg-tertiary-50 hover:border-tertiary-dark hover:text-tertiary-dark active:border-tertiary-light active:text-tertiary-light',
    success: 'hover:bg-success-50 hover:border-success-dark hover:text-success-dark active:border-success-light active:text-success-light',
    info: 'hover:bg-info-50 hover:border-info-dark hover:text-info-dark active:border-info-light active:text-info-light',
    control: 'hover:bg-control-100 hover:border-control-dark active:border-control-light active:text-control-light',
    black: 'hover:bg-control-100 hover:border-control-dark active:border-control-light active:text-control-light',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'hover:bg-slate-50 hover:border-slate-700 hover:text-slate-700 active:border-slate-300 active:text-slate-300',
    zinc: 'hover:bg-zinc-50 hover:border-zinc-700 hover:text-zinc-700 active:border-zinc-300 active:text-zinc-300',
    neutral: 'hover:bg-neutral-50 hover:border-neutral-700 hover:text-neutral-700 active:border-neutral-300 active:text-neutral-300',
    stone: 'hover:bg-stone-50 hover:border-stone-700 hover:text-stone-700 active:border-stone-300 active:text-stone-300',
    red: 'hover:bg-red-50 hover:border-red-700 hover:text-red-700 active:border-red-300 active:text-red-300',
    orange: 'hover:bg-orange-50 hover:border-orange-700 hover:text-orange-700 active:border-orange-300 active:text-orange-300',
    amber: 'hover:bg-amber-50 hover:border-amber-700 hover:text-amber-700 active:border-amber-300 active:text-amber-300',
    yellow: 'hover:bg-yellow-50 hover:border-yellow-700 hover:text-yellow-700 active:border-yellow-300 active:text-yellow-300',
    lime: 'hover:bg-lime-50 hover:border-lime-700 hover:text-lime-700 active:border-lime-300 active:text-lime-300',
    green: 'hover:bg-green-50 hover:border-green-700 hover:text-green-700 active:border-green-300 active:text-green-300',
    emerald: 'hover:bg-emerald-50 hover:border-emerald-700 hover:text-emerald-700 active:border-emerald-300 active:text-emerald-300',
    teal: 'hover:bg-teal-50 hover:border-teal-700 hover:text-teal-700 active:border-teal-300 active:text-teal-300',
    cyan: 'hover:bg-cyan-50 hover:border-cyan-700 hover:text-cyan-700 active:border-cyan-300 active:text-cyan-300',
    sky: 'hover:bg-sky-50 hover:border-sky-700 hover:text-sky-700 active:border-sky-300 active:text-sky-300',
    blue: 'hover:bg-blue-50 hover:border-blue-700 hover:text-blue-700 active:border-blue-300 active:text-blue-300',
    indigo: 'hover:bg-indigo-50 hover:border-indigo-700 hover:text-indigo-700 active:border-indigo-300 active:text-indigo-300',
    violet: 'hover:bg-violet-50 hover:border-violet-700 hover:text-violet-700 active:border-violet-300 active:text-violet-300',
    purple: 'hover:bg-purple-50 hover:border-purple-700 hover:text-purple-700 active:border-purple-300 active:text-purple-300',
    fuchsia: 'hover:bg-fuchsia-50 hover:border-fuchsia-700 hover:text-fuchsia-700 active:border-fuchsia-300 active:text-fuchsia-300',
    pink: 'hover:bg-pink-50 hover:border-pink-700 hover:text-pink-700 active:border-pink-300 active:text-pink-300',
    rose: 'hover:bg-rose-50 hover:border-rose-700 hover:text-rose-700 active:border-rose-300 active:text-rose-300'
};
exports.REVERSE_HOVER_COLORS = {
    primary: 'hover:bg-primary-400 hover:border-primary-400 hover:text-primary-900 active:border-primary-700 active:text-primary-700',
    secondary: 'hover:bg-secondary-400 hover:border-secondary-400 hover:text-secondary-900 active:border-secondary-700 active:text-secondary-700',
    tertiary: 'hover:bg-tertiary-400 hover:border-tertiary-400 hover:text-tertiary-900 active:border-tertiary-700 active:text-tertiary-700',
    info: 'hover:bg-info-400 hover:border-info-400 hover:text-info-900 active:border-info-700 active:text-info-700',
    danger: 'hover:bg-danger-400 hover:border-danger-400 hover:text-danger-900 active:border-danger-700 active:text-danger-700',
    warning: 'hover:bg-warning-400 hover:border-warning-400 hover:text-warning-900 active:border-warning-700 active:text-warning-700',
    success: 'hover:bg-success-400 hover:border-success-400 hover:text-success-900 active:border-success-700 active:text-success-700',
    control: 'hover:bg-control-400 hover:border-control-400 hover:text-control-900 active:border-control-700 active:text-control-700',
    black: 'hover:bg-black-400 hover:border-black-400 hover:text-black-900 active:border-black-700 active:text-black-700',
    inherit: 'bg-transparent hover:bg-transparent',
    purple: 'hover:bg-purple-400 hover:border-purple-400 hover:text-purple-900 active:border-purple-700 active:text-purple-700',
    slate: 'hover:bg-slate-400 hover:border-slate-400 hover:text-slate-900 active:border-slate-700 active:text-slate-700',
    zinc: 'hover:bg-zinc-400 hover:border-zinc-400 hover:text-zinc-900 active:border-zinc-700 active:text-zinc-700',
    neutral: 'hover:bg-neutral-400 hover:border-neutral-400 hover:text-neutral-900 active:border-neutral-700 active:text-neutral-700',
    stone: 'hover:bg-stone-400 hover:border-stone-400 hover:text-stone-900 active:border-stone-700 active:text-stone-700',
    red: 'hover:bg-red-400 hover:border-red-400 hover:text-red-900 active:border-red-700 active:text-red-700',
    orange: 'hover:bg-orange-400 hover:border-orange-400 hover:text-orange-900 active:border-orange-700 active:text-orange-700',
    amber: 'hover:bg-amber-400 hover:border-amber-400 hover:text-amber-900 active:border-amber-700 active:text-amber-700',
    yellow: 'hover:bg-yellow-400 hover:border-yellow-400 hover:text-yellow-900 active:border-yellow-700 active:text-yellow-700',
    lime: 'hover:bg-lime-400 hover:border-lime-400 hover:text-lime-900 active:border-lime-700 active:text-lime-700',
    green: 'hover:bg-green-400 hover:border-green-400 hover:text-green-900 active:border-green-700 active:text-green-700',
    emerald: 'hover:bg-emerald-400 hover:border-emerald-400 hover:text-emerald-900 active:border-emerald-700 active:text-emerald-700',
    teal: 'hover:bg-teal-400 hover:border-teal-400 hover:text-teal-900 active:border-teal-700 active:text-teal-700',
    cyan: 'hover:bg-cyan-400 hover:border-cyan-400 hover:text-cyan-900 active:border-cyan-700 active:text-cyan-700',
    sky: 'hover:bg-sky-400 hover:border-sky-400 hover:text-sky-900 active:border-sky-700 active:text-sky-700',
    blue: 'hover:bg-blue-400 hover:border-blue-400 hover:text-blue-900 active:border-blue-700 active:text-blue-700',
    indigo: 'hover:bg-indigo-400 hover:border-indigo-400 hover:text-indigo-900 active:border-indigo-700 active:text-indigo-700',
    violet: 'hover:bg-violet-400 hover:border-violet-400 hover:text-violet-900 active:border-violet-700 active:text-violet-700',
    fuchsia: 'hover:bg-fuchsia-400 hover:border-fuchsia-400 hover:text-fuchsia-900 active:border-fuchsia-700 active:text-fuchsia-700',
    pink: 'hover:bg-pink-400 hover:border-pink-400 hover:text-pink-900 active:border-pink-700 active:text-pink-700',
    rose: 'hover:bg-rose-400 hover:border-rose-400 hover:text-rose-900 active:border-rose-700 active:text-rose-700'
};
exports.ROUNDED = {
    full: 'rounded-full',
    huge: 'rounded-3xl',
    large: 'rounded-2xl',
    medium: 'rounded-lg',
    small: 'rounded',
    tiny: 'rounded-sm',
    none: 'rounded-none'
};
exports.TYPOGRAPHY = {
    huge: text_props_1.TypographyEnum['base'],
    large: text_props_1.TypographyEnum['sm'],
    medium: text_props_1.TypographyEnum['xs'],
    small: text_props_1.TypographyEnum['xs'],
    tiny: text_props_1.TypographyEnum['xs']
};
exports.ICON_SIZE = {
    tiny: 16,
    small: 18,
    medium: 22,
    large: 22,
    huge: 22
};
//# sourceMappingURL=chip.style.js.map